import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { PropType } from 'vue';
import { RouterLink, RouteLocationRaw } from 'vue-router';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmRouterLink',
  props: {
  /**Активность */
  isDisabled: { type: Boolean, default: false },
  /**Путь */
  to: { type: [String, Object] as PropType<RouteLocationRaw> },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.isDisabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_openBlock(), _createBlock(_unref(RouterLink), {
        key: 1,
        to: __props.to
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"]))
}
}

})